/**
 * Normalizes an array of validation error objects by grouping messages by their path.
 *
 * @param {Array<{ path: string, message: string }>} errors - The array of error objects to normalize.
 * @param {Boolean} giveCount - Return count as message if more than 1 error.
 * @returns {Array<Object>} An array of normalized error objects. Each object contains:
 *   - `path` {string}: The error path.
 *   - `message` {string}: The primary (first) error message for the path.
 *   - `count` {number} [optional]: The number of messages for the path (if more than one).
 *   - `messages` {string[]} [optional]: All error messages for the path (if more than one).
 */
function normalizeValidationErrors({ errors, giveCount = false }) {
  const grouped = errors.reduce((acc, { path, message }) => {
    if (!acc[path]) acc[path] = [];
    acc[path].push(message);
    return acc;
  }, {});

  return Object.entries(grouped).map(([path, messages]) => {
    if (messages.length === 1) {
      return {
        path,
        message: messages[0],
      };
    }
    return {
      path,
      message:
        giveCount && messages.length > 1
          ? `Please check form errors section, has ${messages.length} errors`
          : messages[0],
      count: messages.length,
      messages,
    };
  });
}

export default normalizeValidationErrors;
